import { IconAlertTriangle } from '@tabler/icons-react';
import { RevisionDevice } from 'components/forms/revision/fill-out/types';
import { useDeviceFault } from 'components/forms/revision/fill-out/modals/device-fault-modal/DeviceFaultProvider';
import { useFillOutRevisionDataProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionDataProvider';
import { useMemo } from 'react';
import Button from 'components/Button';
import { useFillOutRevisionSaveDraftProvider } from 'components/forms/revision/fill-out/data/FillOutRevisionSaveDraftProvider';

/**
 * The button which opens a dialog for adding device faults.
 */
export default function DeviceFaultsButton({ device: { faults, deviceId } }: { device: RevisionDevice }) {
  const { specifyFaults } = useDeviceFault();
  const { revision, form, tabHasVisibleInputs } = useFillOutRevisionDataProvider();
  const { saveDraft } = useFillOutRevisionSaveDraftProvider();
  const hasVisibleInputs = useMemo(() => tabHasVisibleInputs('faults'), [tabHasVisibleInputs]);

  /** Opens the device fault modal. */
  const openFaultsModal = () =>
    specifyFaults({
      deviceTypeId: revision.deviceType.deviceTypeId,
      initialValues: { faults },
      onSubmit: ({ faults }) => {
        const nextData = {
          ...form.values,
          devices: {
            ...form.values.devices,
            [deviceId]: { ...form.values.devices[deviceId], faults },
          },
        };
        form.setValues(nextData);
        saveDraft({ notify: false, overrideData: nextData });
      },
    });

  if (!hasVisibleInputs) {
    return null;
  }

  return (
    <Button size="md" variant="subtle" leftIcon={<IconAlertTriangle stroke="1.5" />} onClick={openFaultsModal}>
      Nedostatky zariadenia {faults.length > 0 && `(${faults.length})`}
    </Button>
  );
}
